import React from 'react';
import { Pagination, PaginationItem, Stack } from '@mui/material';
import { ArrowLeft, ArrowRight } from '@mui/icons-material';
import { useInvoicesContext } from './InvoicesContext';

export const InvoicesPagination = () => {
  const {
    pagination: { page, onPageChange, count },
  } = useInvoicesContext();

  if (!count) {
    return null;
  }

  return (
    <Stack alignItems={'center'} sx={{ mt: 6 }}>
      <Pagination
        page={page}
        onChange={(_, value) => onPageChange(value)}
        count={count}
        color="primary"
        sx={(theme) => ({
          backgroundColor: 'primary.light',
          width: 'fit-content',
          borderRadius: theme.spacing(10),
          height: theme.spacing(8),
          display: 'flex',
        })}
        renderItem={(item) => <PaginationItem slots={{ previous: ArrowLeft, next: ArrowRight }} {...item} />}
      />
    </Stack>
  );
};
